import WeightInputImperial from './WeightInputImperial';

export default WeightInputImperial;
